<div class="encabezado-modal">
  <h2 mat-dialog-title class="titulo">Asignar depósito a cliente</h2>
  <button type="button" class="cerrar-x" aria-label="Cerrar" (click)="cerrar()" [disabled]="enviando">×</button>
</div>

<mat-dialog-content class="contenido">
  <div class="resumen-deposito">
    <div class="dato">
      <span class="etiqueta">Monto</span>
      <span class="valor monto">{{ deposito.amount }} {{ deposito.coin }}</span>
    </div>
    <div class="dato">
      <span class="etiqueta">Red</span>
      <span class="valor">{{ deposito.network }}</span>
    </div>
    <div class="dato">
      <span class="etiqueta">Llegada</span>
      <span class="valor">{{ deposito.insertTime | date: 'short' }}</span>
    </div>
    <div class="dato ancho">
      <span class="etiqueta">TxId (listado)</span>
      <span class="valor tx">{{ deposito.txId }}</span>
    </div>
  </div>

  <section class="bloque">
    <h3>1. Cliente</h3>
    <form class="busqueda" (ngSubmit)="buscar()">
      <mat-form-field appearance="outline" class="filtro">
        <mat-label>Buscar por</mat-label>
        <mat-select [(ngModel)]="filtro" name="filtro" [disabled]="enviando">
          <mat-option *ngFor="let f of filtros" [value]="f.valor">{{ f.texto }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="texto">
        <mat-label>Valor</mat-label>
        <input matInput [(ngModel)]="busqueda" name="busqueda" [disabled]="enviando" autocomplete="off" />
      </mat-form-field>
      <button type="submit" class="btn secundario" [disabled]="!busqueda.trim() || buscando || enviando">
        {{ buscando ? 'Buscando…' : 'Buscar' }}
      </button>
    </form>
    <p class="aviso error" *ngIf="errorBusqueda">{{ errorBusqueda }}</p>
    <p class="aviso" *ngIf="buscado && !buscando && !errorBusqueda && !resultados.length">
      No hay clientes con ese dato.
    </p>
    <ul class="resultados" *ngIf="resultados.length">
      <li *ngFor="let u of resultados">
        <button
          type="button"
          class="cliente"
          [class.elegido]="cliente?.usuarioId === u.usuarioId"
          [disabled]="enviando"
          (click)="elegir(u)"
        >
          <span class="nombre">{{ nombre(u) }}</span>
          <span class="detalle">ID {{ u.usuarioId }} · {{ u.email }}</span>
        </button>
      </li>
    </ul>
  </section>

  <section class="bloque">
    <h3>2. TxId y red</h3>
    <mat-form-field appearance="outline" class="completo" subscriptSizing="dynamic">
      <mat-label>TxId completo</mat-label>
      <input
        matInput
        [(ngModel)]="txId"
        name="txId"
        [disabled]="enviando"
        autocomplete="off"
        [placeholder]="sufijo ? '… termina en ' + sufijo : ''"
      />
      <mat-hint>El listado oculta el TxId: pega el que dio el cliente o Binance. Debe terminar en «{{ sufijo }}».</mat-hint>
    </mat-form-field>
    <p class="aviso error" *ngIf="txId.trim() && !txIdValido">El TxId no corresponde a este depósito.</p>
    <p class="red">Red: <strong>{{ deposito.network }}</strong></p>
  </section>

  <section class="bloque">
    <h3>3. Motivo</h3>
    <mat-form-field appearance="outline" class="completo" subscriptSizing="dynamic">
      <mat-label>Motivo de la asignación</mat-label>
      <textarea
        matInput
        rows="2"
        [(ngModel)]="motivo"
        name="motivo"
        [disabled]="enviando"
        [maxlength]="maxMotivo"
      ></textarea>
      <mat-hint>Queda con tu usuario en el registro interno. El cliente solo ve «Depósito confirmado por soporte». No escribas datos del cliente (documento, cuentas, teléfono).</mat-hint>
      <mat-hint align="end">{{ motivo.length }}/{{ maxMotivo }}</mat-hint>
    </mat-form-field>
  </section>

  <p class="confirmacion" *ngIf="cliente">
    Vas a acreditar <strong>{{ deposito.amount }} {{ deposito.coin }}</strong> a
    <strong>{{ nombre(cliente) }}</strong> (ID {{ cliente.usuarioId }}).
  </p>
  <p class="aviso error" *ngIf="error" role="alert">{{ error }}</p>
</mat-dialog-content>

<mat-dialog-actions class="acciones">
  <button type="button" class="btn secundario" (click)="cerrar()" [disabled]="enviando">Cancelar</button>
  <button type="button" class="btn primario" (click)="confirmar()" [disabled]="!puedeConfirmar">
    <mat-spinner *ngIf="enviando" diameter="16"></mat-spinner>
    {{ enviando ? 'Asignando…' : 'Asignar' }}
  </button>
</mat-dialog-actions>
